import React from 'react'
import { ProductCardParent } from '../../products/components/ProductCard/ProductCardParent'
import { Product } from '../../products/storage'

interface SeedEditPriceProductCardProps {
  item?: Product
}

export const SeedEditPriceProductCard = ({ item }: SeedEditPriceProductCardProps) => {
  const renderQuickOrderButton = null

  const renderSideContainer = null

  if (!item) return null

  return (
    <ProductCardParent
      item={item}
      renderQuickOrderButton={renderQuickOrderButton}
      renderSideContainer={renderSideContainer}
      showImage={false}
    />
  )
}
